export default "__VITE_ASSET__35d6833e__"